export enum NotificationChannel {
  WEB = 'WEB',
  TELEGRAM = 'TELEGRAM',
  EMAIL = 'EMAIL',
}
